export default __webpack_public_path__ + "images/session-bg-2.png?e5685468ee9c8239474b8c8ba7551cb8";